import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { NotificationType } from '@/types/dashboardTypes';

export const getNotificationsApi = (): Promise<ApiResponseType<{ results: NotificationType[]; unread: number }>> => {
  return authApiService.GET('/dashboard/notifications/');
};

export const getUnreadCountApi = (): Promise<ApiResponseType<{ unread: number }>> => {
  return authApiService.GET('/dashboard/notifications/unread/');
};

export const markNotificationsReadApi = (
  ids: string[]
): Promise<ApiResponseType<{ updated: number; unread: number }>> => {
  return authApiService.POST('/dashboard/notifications/read/', { ids });
};

export const markAllNotificationsReadApi = (): Promise<ApiResponseType<{ updated: number; unread: number }>> => {
  return authApiService.POST('/dashboard/notifications/read-all/', {});
};
